import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin, ChevronRight, CalendarX } from 'lucide-react';
import type { VenueEvent } from '../data/events';
interface EventsListViewProps {
  events: VenueEvent[];
}
export function EventsListView({
  events
}: EventsListViewProps) {
  if (events.length === 0) {
    return <EmptyState data-id="element-302" />;
  }
  return <div className="space-y-4" data-id="element-303">
      {events.map((event, index) => <motion.div key={event.id} initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: index * 0.05,
      duration: 0.4
    }} className="group bg-[#11161A] border border-white/10 hover:border-[#DDA247] transition-all duration-300 overflow-hidden cursor-pointer" data-id="element-304">
          <div className="flex flex-col md:flex-row" data-id="element-305">
            {/* Image */}
            <div className="relative w-full md:w-64 h-64 md:h-48 overflow-hidden shrink-0" data-id="element-306">
              <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-307" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#11161A]/50" data-id="element-308" />
            </div>

            {/* Content */}
            <div className="flex-1 p-6 flex flex-col justify-between" data-id="element-309">
              <div data-id="element-310">
                <div className="flex items-start justify-between mb-3" data-id="element-311">
                  <div data-id="element-312">
                    <div className="flex flex-wrap items-center gap-2 mb-3" data-id="element-313">
                      <span className="inline-block bg-[#DDA247] text-[#0B1014] px-3 py-1 text-xs font-bold uppercase tracking-wider" data-id="element-314">
                        {event.type}
                      </span>
                      <span className="inline-block text-[#DDA247] border border-[#DDA247]/30 px-3 py-1 text-[10px] font-bold uppercase tracking-widest rounded-full" data-id="element-315">
                        {event.category}
                      </span>
                    </div>
                    <h3 className="text-2xl font-bold text-white uppercase tracking-wide mb-1" data-id="element-316">
                      {event.title}
                    </h3>
                    <p className="text-[#DDA247] text-xl font-bold mb-4" data-id="element-317">
                      {event.artist}
                    </p>
                  </div>
                  <ChevronRight className="text-gray-400 group-hover:text-[#DDA247] transition-colors" data-id="element-318" />
                </div>

                <div className="flex flex-wrap gap-4 text-sm text-gray-400" data-id="element-319">
                  <div className="flex items-center" data-id="element-320">
                    <Calendar className="w-4 h-4 mr-2 text-[#DDA247]" data-id="element-321" />
                    <span data-id="element-322">{event.fullDate}</span>
                  </div>
                  <div className="flex items-center" data-id="element-323">
                    <Clock className="w-4 h-4 mr-2 text-[#DDA247]" data-id="element-324" />
                    <span data-id="element-325">{event.time}</span>
                  </div>
                  <div className="flex items-center" data-id="element-326">
                    <MapPin className="w-4 h-4 mr-2 text-[#DDA247]" data-id="element-327" />
                    <span data-id="element-328">{event.venue}</span>
                  </div>
                </div>
              </div>

              <div className="mt-4 flex items-center justify-between" data-id="element-329">
                <button className="bg-[#DDA247] text-[#0B1014] px-6 py-2 text-sm font-bold uppercase tracking-wider hover:bg-white transition-colors" data-id="element-330">
                  Buy Tickets
                </button>
                <span className="text-gray-500 text-sm" data-id="element-331">View Details →</span>
              </div>
            </div>
          </div>
        </motion.div>)}
    </div>;
}
function EmptyState() {
  return <div className="flex flex-col items-center justify-center text-center py-24 bg-[#11161A] border border-white/10 rounded-2xl" data-id="element-332">
      <div className="inline-flex items-center justify-center w-16 h-16 mb-5 bg-[#DDA247]/10 rounded-full" data-id="element-333">
        <CalendarX className="w-8 h-8 text-[#DDA247]" data-id="element-334" />
      </div>
      <h3 className="text-xl font-bold text-white mb-2 tracking-wide" data-id="element-335">
        No Events Found
      </h3>
      <p className="text-gray-400 text-sm max-w-sm" data-id="element-336">
        Try adjusting your filters or clearing them to see all upcoming events.
      </p>
    </div>;
}